/**
 * Index of a metric column within an explicit preferred order (Figma maquette order).
 * Strips a trailing Compare/Diff suffix so comparison columns track their base metric.
 * Returns -1 when no order is given or the field isn't listed, so callers can fall
 * back to the KPI catalog `order`.
 */
export const columnOrderIndex = (field: string, columnOrder?: string[]): number => {
  if (!columnOrder?.length) return -1;
  const base = field.replace(/Compare$/, '').replace(/Diff$/, '');
  return columnOrder.indexOf(base);
};
